import CartJS from 'shopify-cartjs'
theme.ajaxCart = function () {
  let drawerTimeout = null
  quickshop()
  gridAddToCart()
  prodAddToCart()

  $('.continue-shopping, .modalOverly, .closeDrawer').click(function () {
    $('.modal').fadeOut(200)
    $('body').removeClass('loading showOverly')
  })

  function quickshop() {
    $(document).on('click touch', '.quickShop', function (e) {
      e.preventDefault()
      e.stopImmediatePropagation()
      var url = $(this).attr('href'),
        imgwrapper = $(this)
          .parents('.grid-view-item')
          .find('.grid-view_image'),
        wrapper = $(this).parents('.grid-view-item').find('.shopWrapper')

      $.ajax({
        url: url,
        dataType: 'html',
        type: 'GET',
        beforeSend: function () {
          $(imgwrapper).append("<i class='ad ad-spinner4 ad-spin'></i>")
          $(imgwrapper).addClass('showLoading')
        },
        success: function (data) {
          $('.shopWrapper').removeClass('active').html('')
          $(wrapper).addClass('active').html(data)

          theme.quickajaxCart = function () {
            let drawerTimeout = null
            prodAddToCart()

            function prodAddToCart() {
              if (theme.ajax_cart) {
                var props = {}

                // $(".quickshop-cart").click(function (i) {
                //   if (
                //     (i.preventDefault(), "disabled" != $(this).attr("disabled"))
                //   )
                //     var att = $(this)
                //       .closest("form")
                //       .find("select[name=id]")
                //       .val();
                //   att ||
                //     (att = $(this)
                //       .closest("form")
                //       .find("input[name=id]")
                //       .val());
                //   var qty = $(this)
                //     .closest("form")
                //     .find("input[name=quantity]")
                //     .val();
                //   qty || (qty = 1);
                //   console.log(att, qty);

                //   if ($(".swatch--color").length > 0) {
                //     $(".swatch--color").each(function () {
                //       var key = "Color";
                //       var value = $(this).find(".swatch__header span").html();
                //       props[key] = value;
                //     });
                //   }

                //   addinToCart(att, qty, props);
                //   return;
                // });

                $('.swatchInput').each(function (index, elem) {
                  $(elem).on('click', function (e) {
                    setTimeout(() => {
                      if ($(this).parent().hasClass('soldout')) return

                      var att = $(this)
                        .closest('form')
                        .find('select[name=id]')
                        .val()
                      att ||
                        (att = $(this)
                          .closest('form')
                          .find('input[name=id]')
                          .val())
                      var qty = $(this)
                        .closest('form')
                        .find('input[name=quantity]')
                        .val()
                      qty || (qty = 1)
                      if ($('.swatch--color').length > 0) {
                        $('.swatch--color').each(function () {
                          var key = 'Color'
                          var value = $(this)
                            .find('.swatch__header span')
                            .html()
                          props[key] = value
                        })
                      }
                      addinToCart(att, qty, props)

                      return
                    }, 550)
                  })
                  // $(elem).change(function (i) {
                  //   setTimeout(() => {
                  //     console.log($(this).parent());
                  //     if ($(this).parent().hasClass("soldout")) return;

                  //     var att = $(this)
                  //       .closest("form")
                  //       .find("select[name=id]")
                  //       .val();
                  //     att ||
                  //       (att = $(this)
                  //         .closest("form")
                  //         .find("input[name=id]")
                  //         .val());
                  //     var qty = $(this)
                  //       .closest("form")
                  //       .find("input[name=quantity]")
                  //       .val();
                  //     qty || (qty = 1);
                  //     if ($(".swatch--color").length > 0) {
                  //       $(".swatch--color").each(function () {
                  //         var key = "Color";
                  //         var value = $(this)
                  //           .find(".swatch__header span")
                  //           .html();
                  //         props[key] = value;
                  //       });
                  //     }
                  //     addinToCart(att, qty, props);

                  //     return;
                  //   }, 550);
                  // });
                })
              }
            }
            function addinToCart(att, qty, props) {
              $('body').addClass('loading')

              CartJS.addItem(att, qty, props, {
                success: function (data, textStatus, jqXHR) {
                  setTimeout(function () {
                    $('body').removeClass('loading showOverly')
                    $('.block-cart').addClass('active')
                  }, 1000)
                  drawerTimeout = setTimeout(function () {
                    $('.block-cart').removeClass('active')
                  }, 7000)
                },
                error: function (jqXHR, textStatus, errorThrown) {
                  var errormsg = JSON.parse(jqXHR.responseText).description
                  $('body').removeClass('loading')
                  $('.error-message').text(errormsg)
                  $('body').addClass('showOverly')
                  $('#errorDrawer').fadeIn(500)
                  drawerTimeout = setTimeout(function () {
                    $('body').removeClass('loading showOverly'),
                      $('#errorDrawer').fadeOut(200)
                  }, 6000)
                },
              })
            }
          }
          $(theme.quickajaxCart)
        },
        complete: function (data) {
          $(imgwrapper).removeClass('showLoading')
          $(imgwrapper).find('.ad-spinner4').remove()
          if (theme.mlcurrency) {
            currenciesChange(
              '.shopWrapper.active .product-single__price span.money'
            )
          }
        },
      })
    })
    $(document).on('click touch', '.closeShop', function (e) {
      e.preventDefault()
      $(this).parents('.shopWrapper').removeClass('active')
    })
  }

  function gridAddToCart() {
    $(document).on('click touch', '.add-to-cart', function (i) {
      i.preventDefault()
      i.stopImmediatePropagation()
      if (theme.ajax_cart) {
        var att = $(this).attr('id'),
          qty = $(this).attr('rel')
        addinToCart(att, qty)
      } else {
        $(this).next().submit()
      }
      return
    })
  }
  function prodAddToCart() {
    if (theme.ajax_cart) {
      var touchmoved
      $(document)
        .on('click touchend', '.product-form__cart-submit', function (i) {
          if ((i.preventDefault(), 'disabled' != $(this).attr('disabled')))
            if (touchmoved != true) {
              var att = $(this).closest('form').find('select[name=id]').val()
              att ||
                (att = $(this).closest('form').find('input[name=id]').val())
              var qty = $(this)
                .closest('form')
                .find('input[name=quantity]')
                .val()
              qty || (qty = 1)
              var props = {}
              $('[name="selling_plan"]').each(function () {
                var key = $(this).attr('name'),
                  value = $(this).val()
                props[key] = value
              })
              $('[name*="properties"]').each(function () {
                var key = $(this).attr('name').split('[')[1].split(']')[0]
                var value = $(this).val()
                props[key] = value
              })
              if ($('.swatch--color').length > 0) {
                $('.swatch--color').each(function () {
                  var key = 'Color'
                  var value = $(this).find('.swatch__header span').html()
                  props[key] = value
                })
              }

              addinToCart(att, qty, props)
            }
          return
        })
        .on('touchmove', function (e) {
          touchmoved = true
        })
        .on('touchstart', function () {
          touchmoved = false
        })
    }
  }
  function addinToCart(att, qty, props) {
    $('body').addClass('loading')

    CartJS.addItem(att, qty, props, {
      success: function (data, textStatus, jqXHR) {
        setTimeout(function () {
          $('body').removeClass('loading showOverly')
          $('.block-cart').addClass('active')
        }, 1000)
        drawerTimeout = setTimeout(function () {
          $('.block-cart').removeClass('active')
        }, 7000)
      },
      error: function (jqXHR, textStatus, errorThrown) {
        var errormsg = JSON.parse(jqXHR.responseText).description
        $('body').removeClass('loading')
        $('.error-message').text(errormsg)
        $('body').addClass('showOverly')
        $('#errorDrawer').fadeIn(500)
        drawerTimeout = setTimeout(function () {
          $('body').removeClass('loading showOverly'),
            $('#errorDrawer').fadeOut(200)
        }, 6000)
      },
    })
  }

  $(document).on('cart.requestComplete', function (event, cart) {
    if (theme.mlcurrency) {
      currenciesChange('#cart-drawer sapn.money')
    }
  })
}
